import React from 'react';

import PhoneBlueIcon from '../assets/images/svgs/phone-blue-26.svg';
import { CalendarIcon } from '../assets/images/svgs';
import OutgoingCallIcon from '../assets/images/svgs/outgoing-call-26.svg';
interface ScheduleCTAProps {
  peerName: string;
  nextAvailableTime: string;
  availableNow?: boolean;
  hasNoAvailability?: boolean;
  onCallButNoAvailability?: boolean;
  onScheduleClick: () => void;
  onSeeMoreTimesClick: () => void;
  onHowDoesCallWorkClick: () => void;
  onSeeMoreListenersClick?: () => void;
  className?: string;
}

export const ScheduleCTA: React.FC<ScheduleCTAProps> = ({
  peerName,
  nextAvailableTime,
  availableNow = false,
  hasNoAvailability = false,
  onCallButNoAvailability = false,
  onScheduleClick,
  onSeeMoreTimesClick,
  onHowDoesCallWorkClick,
  onSeeMoreListenersClick,
  className = '',
}) => {
  // No availability state
  if (hasNoAvailability) {
    return (
      <div
        className={`bg-see-more mx-auto flex h-[318px] w-full max-w-[303px] flex-col items-center justify-center gap-2 rounded-xl px-6 py-5 ${className}`}
      >
        <div className="flex w-full flex-col items-center justify-center gap-2">
          <div className="flex h-[37px] w-[37px] shrink-0 items-center justify-center">
            {/* TODO: This is different than the other phone icons like PhoneBlueIcon and PhoneGrey26, not sure if that's on purpose */}
            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
              <path
                d="M36.6204 31.0913C34.5246 36.1171 29.6106 36.998 28.0048 36.998C27.5332 36.998 20.1896 37.3874 9.63307 27.3714C1.13748 19.3107 0.0994255 10.6427 0.00898121 8.99579C-0.0789964 7.39163 0.380214 3.36747 5.91458 0.377517C6.60031 0.00701103 7.95986 -0.157064 8.31094 0.194114C8.46675 0.349965 13.1119 7.99571 13.234 8.24902C13.3561 8.50192 13.4173 8.75111 13.4173 8.99538C13.4173 9.3445 13.1686 9.78121 12.6708 10.3051C12.1733 10.829 11.6323 11.3093 11.0473 11.7456C10.4623 12.1823 9.92126 12.6449 9.42341 13.1339C8.92597 13.6224 8.67724 14.0246 8.67724 14.3387C8.71095 15.1542 9.37901 18.075 14.4681 22.5478C19.5581 27.0219 22.01 28.2822 22.2455 28.3694C22.4815 28.4566 22.6776 28.4998 22.8347 28.4998C23.1492 28.4998 23.5508 28.2514 24.0396 27.7538C24.528 27.2558 26.1712 25.0032 26.695 24.5052C27.2187 24.0081 27.6553 23.7593 28.0048 23.7593C28.249 23.7593 28.4977 23.8201 28.7505 23.9423C29.0038 24.0644 36.6574 28.5442 36.8038 28.6939C37.2009 29.101 36.9205 30.3716 36.6204 31.0913Z"
                fill="rgb(var(--color-icon-slate))"
              />
            </svg>
          </div>
          <div className="flex flex-col items-center justify-center">
            <p className="font-open-sans text-muted-text-gray py-2 text-center text-lg font-medium leading-7 tracking-[-0.4px]">
              {peerName}'s schedule is full at this time'.
            </p>
          </div>
        </div>

        <div className="flex w-full flex-col">
          <button
            onClick={onSeeMoreListenersClick}
            className="bg-button-primary hover:bg-button-primary-hover flex w-full items-center justify-center gap-1.5 rounded-full px-7 py-2.5 transition-colors"
          >
            <p className="font-open-sans text-base font-medium leading-5 text-white">See more Listeners</p>
            <div className="flex h-5 w-5 shrink-0 items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="9"
                viewBox="0 0 14 9"
                fill="none"
                className="h-4 w-4"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.57741 0.244078C8.90285 -0.0813592 9.43048 -0.0813593 9.75592 0.244078L13.0893 3.57741C13.2455 3.73369 13.3333 3.94565 13.3333 4.16667C13.3333 4.38768 13.2455 4.59964 13.0893 4.75592L9.75592 8.08926C9.43049 8.41469 8.90285 8.41469 8.57741 8.08926C8.25197 7.76382 8.25197 7.23618 8.57741 6.91074L10.4882 5H0.833333C0.373096 5 0 4.6269 0 4.16667C0 3.70643 0.373096 3.33333 0.833333 3.33333H10.4882L8.57741 1.42259C8.25197 1.09715 8.25197 0.569515 8.57741 0.244078Z"
                  fill="white"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    );
  }

  // On call but no availability state
  if (onCallButNoAvailability) {
    return (
      <div
        className={`bg-see-more mx-auto flex h-[318px] w-full max-w-[303px] flex-col items-center justify-center gap-4 rounded-xl px-6 py-5 ${className}`}
      >
        <div className="flex h-[90px] w-full flex-col items-center justify-center gap-2">
          <div className="flex h-[37px] w-[37px] shrink-0 items-center justify-center">
            <img src={PhoneBlueIcon} alt="Phone" className="h-[37px] w-[37px]" />
          </div>
          <div className="flex flex-col items-center justify-center">
            <p className="font-open-sans text-center text-lg font-medium leading-8 tracking-[-0.4px] text-black">
              Connect with{peerName}
            </p>
          </div>
        </div>

        <div className="flex w-full flex-col gap-4">
          <div className="flex w-full flex-col">
            <button
              onClick={onScheduleClick}
              className="bg-success hover:bg-success-hover flex w-full items-center justify-center gap-1.5 rounded-full px-7 py-2.5 transition-colors"
            >
              <div className="flex h-5 w-5 shrink-0 items-center justify-center">
                <img src={OutgoingCallIcon} alt="Call now" className="h-5 w-5" />
              </div>
              <p className="font-open-sans text-base font-medium leading-5 text-white">Call now</p>
            </button>
          </div>

          <div className="flex w-full flex-col items-center gap-0">
            <button
              onClick={onHowDoesCallWorkClick}
              className="text-primary font-open-sans hover:text-button-primary text-center text-sm font-medium leading-6 no-underline transition-colors"
            >
              How does a call work?
            </button>
            <div className="border-primary h-px w-[144px] border-t" />
          </div>
        </div>
      </div>
    );
  }

  // Default state (existing behavior)
  return (
    <div
      className={`bg-see-more mx-auto flex h-[318px] w-full max-w-[303px] flex-col items-center justify-center gap-2 rounded-xl px-6 py-4 ${className}`}
    >
      <div className="flex w-full flex-col items-center justify-center gap-0 py-4">
        <div className="flex h-[37px] w-[37px] shrink-0 items-center justify-center pb-4">
          <img src={PhoneBlueIcon} alt="Phone" className="h-[37px] w-[37px]" />
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="font-open-sans text-center text-lg font-medium leading-8 tracking-[-0.4px] text-black">
            Connect with {peerName}
          </p>
        </div>
      </div>

      {availableNow ? null : (
        <div className="flex flex-col justify-end">
          <p className="font-open-sans text-body-gray text-center text-sm font-semibold leading-6 tracking-[0.42px]">
            NEXT AVAILABILITY:
          </p>
        </div>
      )}

      <div className="flex w-full flex-col gap-4">
        <div className="flex w-full flex-col gap-3">
          <button
            onClick={onScheduleClick}
            className={`flex w-full items-center justify-center gap-1.5 rounded-full px-6 py-2.5 transition-colors ${availableNow ? 'bg-success hover:bg-success-hover' : 'bg-button-primary hover:bg-button-primary-hover'}`}
          >
            {availableNow ? (
              <div className="flex h-4 w-4 shrink-0 items-center justify-center">
                <img src={OutgoingCallIcon} alt="Connect to a listener now" className="h-4 w-4" />
              </div>
            ) : (
              <div className="flex h-4 w-4 shrink-0 items-center justify-center">
                <img src={CalendarIcon} alt="Calendar" className="h-4 w-4" />
              </div>
            )}
            <p className="font-open-sans text-base font-medium leading-5 text-white">
              {availableNow ? 'Call now' : nextAvailableTime}
            </p>
          </button>

          <button
            onClick={onSeeMoreTimesClick}
            className="flex w-full items-center justify-center gap-1.5 rounded-full bg-transparent bg-white px-6 py-2.5 transition-colors hover:bg-gray-50"
          >
            <p
              className="text-primary font-open-sans text-base font-normal leading-5"
              style={{ fontVariationSettings: "'wdth' 75" }}
            >
              View Schedule
            </p>
          </button>
        </div>

        <div className="flex w-full flex-col items-center gap-0">
          <button
            onClick={onHowDoesCallWorkClick}
            className="text-primary font-open-sans hover:text-button-primary text-center text-sm font-medium leading-6 no-underline transition-colors"
          >
            What happens on a call?
          </button>
          <div className="border-primary h-px w-[144px] border-t" />
        </div>
      </div>
    </div>
  );
};
